import { render, staticRenderFns } from "./Button_Default.vue?vue&type=template&id=45060f6c&scoped=true&"
import script from "./Button_Default.vue?vue&type=script&lang=js&"
export * from "./Button_Default.vue?vue&type=script&lang=js&"
import style0 from "./Button_Default.vue?vue&type=style&index=0&id=45060f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45060f6c",
  null
  
)

export default component.exports